<div
  (click)="stopPropagation($event)"
  fxLayout="row"
  [fxLayoutAlign]="fxLayoutAlignParam"
  [ngClass]="{
    primary: btnType === 'primary',
    lite: btnType === 'lite',
    secondary: btnType === 'secondary',
    outlined: btnType === 'outlined',
    'text-styling': btnType === 'text',
    tertiary: btnType === 'tertiary',
    underlined: btnType === 'underlined',
    blue: color === 'primary',
    'blue-hover': hoverBackground && color === 'primary',
    danger: color === 'danger',
    'danger-hover': hoverBackground && color === 'danger',
    'danger-without-background': color === 'danger-without-background',
    center: iconPosition === 'center',
    left: icon && iconPosition === 'left-icon',
    right: icon && iconPosition === 'right-icon',
    'disabled-css': disabled,
    'icon-only': iconOnly,
    badge: badge,
    'with-spinnner': !icon && isSpinner,
    'not-allowed-cursor': NotAllowedCursor,
    small: isSmall && !iconOnly,
    'small-icon': isSmall && iconOnly,
    'pill-design': isPillDesign,
  }"
  [tabindex]="0"
  [class.space]="icon && text && !iconOnly"
>
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    [ngClass]="{ icon: iconType === 'mat-icon', 'icon-image': iconType === 'image' }"
  >
    <mat-icon *ngIf="!isSpinning && icon && iconType === 'mat-icon' && !svgIcon"> {{ icon }}</mat-icon>
    <mat-icon *ngIf="!isSpinning && svgIcon && iconType === 'mat-icon'" [svgIcon]="svgIcon"></mat-icon>
    <img *ngIf="!isSpinning && icon && iconType === 'image'" class="svg" [src]="icon" alt="" />
  </div>

  <div *ngIf="!iconOnly" class="text" [class.nowrap-text]="!multilineText">
    <div
      *ngIf="isSpinning"
      [class.loader-instead-of-icon]="icon"
      fxLayout="row"
      fxLayoutAlign="center center"
      class="loader"
    ></div>
    <p>{{ text }}</p>
  </div>

  <div *ngIf="badge" fxLayout="row" fxLayoutAlign="center center" class="badge-container">
    <p>{{ badge }}</p>
  </div>

  <div *ngIf="iconOnly">
    <div *ngIf="isSpinning" class="loadericonOnly"></div>
  </div>

  <ng-content></ng-content>
</div>
